/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import ContainerBase from '@bingads-webui-component-legacy/grid/containerBase';
var ElementContainer = ContainerBase.extend({
  offset: function (element, scrollTop, scrollLeft) {
    var position = $(element).position();
    return {
      top: position.top + this.$el.scrollTop(),
      left: position.left + this.$el.scrollLeft()
    };
  }
});
ElementContainer.isValidContainer = function (userContainer) {
  return ['absolute', 'relative', 'fixed'].indexOf($(userContainer).css('position')) >= 0;
};
export default ElementContainer;

